import { defer } from "react-router-dom";

import { NotFoundError } from "@/modules/errors";
import {
  projectQuery,
  projectStatementsQuery,
} from "@/services/lukita/queries";
import { hasProjectSucceeded } from "@/utils";
import { getAccount, getQueryParams } from "../helpers";

export default async function projectLoader({ request, params }) {
  const { skip, first } = getQueryParams(request.url);
  const url = new URL(request.url);
  const requestPolicy =
    url.searchParams.has("processed") || url.searchParams.has("success")
      ? "network-only"
      : null;

  const account = getAccount();
  const makeQuery = (query) =>
    account
      .then((account) =>
        query({
          slug: params.projectSlug,
          accountId: account?.id,
          skip,
          first,
          requestOptions: { requestPolicy },
        }),
      )
      .then(({ project }) => {
        if (!project) throw new NotFoundError();
        return project;
      });

  const project = makeQuery(projectQuery);

  const projectStatements = project.then((project) => {
    if (hasProjectSucceeded(project)) return null;
    return makeQuery(projectStatementsQuery);
  });

  return defer({ project, projectStatements });
}
